import { Group } from "@mantine/core"
import { Button } from "@tfg/ui"
import { useTranslation } from "react-i18next"

type StepperFooterNavProps = Readonly<{
  isFirstStep: boolean
  isLastStep: boolean
  onBack: () => void
  onNext: () => void
}>

export const StepperFooterNav = ({
  isFirstStep,
  isLastStep,
  onBack,
  onNext,
}: StepperFooterNavProps) => {
  const { t } = useTranslation("supplier")

  return (
    <Group
      component="footer"
      justify="space-between"
      gap="var(--tfg-molecule-padding-y)"
      py="var(--tfg-organism-padding-y)"
      px="var(--tfg-organism-padding-x)"
      bg="var(--mantine-color-white)"
      wrap="nowrap"
      style={{
        flexShrink: 0,
        borderTop: "1px solid var(--mantine-color-ground-1)",
        marginInline: "calc(-1 * var(--tfg-organism-padding-x))",
        marginBottom: "calc(-1 * var(--tfg-organism-padding-y))",
      }}
    >
      <Group gap="var(--tfg-molecule-padding-y)" wrap="nowrap">
        {!isFirstStep ? (
          <Button variant="ghost" onClick={onBack}>
            {t("onboarding.actions.back")}
          </Button>
        ) : null}
      </Group>
      <Group gap="var(--tfg-molecule-padding-y)" wrap="nowrap">
        <Button onClick={onNext}>
          {isLastStep
            ? t("onboarding.actions.activateAccount")
            : t("onboarding.actions.next")}
        </Button>
      </Group>
    </Group>
  )
}
